import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Download } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@shadcn-in-nx/ui/dropdown-menu";

function ExportButton({ onExportCSV, onExportJSON, onExportSQL }) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="flex-shrink-0">
                    <Download className="w-4 h-4 md:mr-2" />
                    <span className="hidden md:inline">Export</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={onExportCSV}>
                    Export as CSV
                </DropdownMenuItem>
                <DropdownMenuItem onClick={onExportJSON}>
                    Export as JSON
                </DropdownMenuItem>
                <DropdownMenuItem onClick={onExportSQL}>
                    Export as SQL
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default ExportButton;
